<template>
  <ControlCommonLayout header="controlHeader" footer="controlFooter">
    <b-overlay :show="overlayShow" rounded="sm">
      <div class="container">
        <div class="main-color text-light row mt-3">
          <div class="col p-2">
            <a id="orderList" class="ml-1 list-type active-list">棚割・注力商品設定</a>
            <a id="orderList" class="ml-1 list-type" @click="goInventorySpecList()">設定状況確認</a>
          </div>
        </div>

        <form method="post" action="#" class="form-horizontal">

          <div class="form-group row">
            <div class="col-sm-3 row">
              <div class="col-sm-12 px-0">
                <label for="area-date" class="control-label col-sm-12">エリア</label>
                <div class="col-sm-12 pr-0">
                  <v-select id="area-date" v-model="searchAreaName" label="label" :options="areaData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="areaData.length <= 0"></v-select>
                </div>
              </div>
            </div>
            <div class="col-sm-3 row">
              <div class="col-sm-12 px-0">
                <label for="unit-date" class="control-label col-sm-12">ユニット</label>
                <div class="col-sm-12 pr-0">
                  <v-select id="unit-date" v-model="searchUnitName" label="label" :options="unitData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="unitData.length <= 0"></v-select>
                </div>
              </div>
            </div>
            <div class="col-sm-3 row">
              <div class="col-sm-12 px-0">
                <label for="facility-date" class="control-label col-sm-12">施設</label>
                <div class="col-sm-12 pr-0">
                  <v-select id="facility-date" v-model="searchFacilityCode" label="label" :options="facilityData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="facilityData.length <= 0"></v-select>
                </div>
              </div>
            </div>
            <div class="col-sm-3 row">
              <div class="col-sm-7 px-0">
                <label for="facility-date" class="control-label col-sm-12">期</label>
                <div class="col-sm-12 pr-0">
                  <v-select id="facility-date" v-model="searchPeriod" label="label" :options="periodData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="periodData.length <= 0"></v-select>
                </div>
              </div>
              <div class="col-sm-5 text-right pr-0">
                <b-button variant="primary" style="margin-top: 30px;" @click="searchFocusPlan()" :disabled="(userRoleMode === 0)">適用</b-button>
              </div>
            </div>
          </div>

        </form>

        <div id="focus-box" class="row mt-3 base-color">
          <div class="accordion col p-0" role="tablist1">
            <b-card no-body>
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.accordion-1 id='focus-bar' class="light-blue text-left text-black" @click="changeIcon(1)"><b-icon id="icon-up_1" icon="chevron-up"></b-icon><b-icon id="icon-down_1" class="hide" icon="chevron-down"></b-icon>&nbsp;注力策定状況</b-button>
              </b-card-header>
              <!-- 注力策定状況BOX -->
              <b-collapse visible id="accordion-1" accordion="my-accordion1" role="tabpanel">
                <b-card-body>
                  <form method="post" action="#" class="form-horizontal">
                    <div class="form-group row">
                      <div class="col-sm-12">
                        <b-overlay :show="overlayPlanListShow" rounded="sm" class="col-sm-12">
                          <b-table-simple bordered class="small">
                            <thead role="rowgroup" class="table-bordered">
                              <tr role="row" class="align-middle">
                                <th rowspan="1" class="align-middle text-center th-head" style="width: 5%;"></th>
                                <th rowspan="1" class="align-middle text-center th-head" style="width: 12%;">メインテーブル</th>
                                <th rowspan="1" class="align-middle text-center th-head" style="width: 9%;">ゲストテーブル</th>
                              </tr>
                              <tr>
                                <th class="align-middle text-center th-head">計画</th>
                                <th class="align-middle text-center th-cell">{{toCommaSeparated(goalData['メインテーブル計画金額'])}}</th>
                                <th class="align-middle text-center th-cell">{{toCommaSeparated(goalData['ゲストテーブル計画金額'])}}</th>
                              </tr>
                              <tr>
                                <th class="align-middle text-center th-head">注力</th>
                                <th class="align-middle text-center th-cell">{{toCommaSeparated(goalData['メインテーブル注力金額'])}}</th>
                                <th class="align-middle text-center th-cell">{{toCommaSeparated(goalData['ゲストテーブル注力金額'])}}</th>
                              </tr>
                              <tr>
                                <th class="align-middle text-center th-head">計画差</th>
                                <th class="align-middle text-center th-cell" :style="goalData['メインテーブル差分金額'] < 0 ? 'color: red;' : ''">{{(goalData['メインテーブル差分金額'] > 0 ? '+' : '')}}{{toCommaSeparated(goalData['メインテーブル差分金額'])}}</th>
                                <th class="align-middle text-center th-cell" :style="goalData['ゲストテーブル差分金額'] < 0 ? 'color: red;' : ''">{{(goalData['ゲストテーブル差分金額'] > 0 ? '+' : '')}}{{toCommaSeparated(goalData['ゲストテーブル差分金額'])}}</th>
                              </tr>
                            </thead>
                          </b-table-simple>
                          <label for="tableNumber" class="control-label" style="margin-left: 81%">ゲストテーブル卓数</label>
                          <div class="form-group row">
                            <input type="text" id="table-number" class="form-control input-sm col-sm-1" style="margin-left:80%" :disabled="!savePossible" v-model="tableNumber"/>
                            <b-button variant="primary" @click="tableNumberRegist()" style="margin-left:1%" :disabled="!savePossible">保存</b-button>
                          </div>
                        </b-overlay>
                      </div>
                    </div>
                  </form>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
        <div id="search-box" class="row mt-3 base-color">
          <div class="accordion col p-0" role="tablist2">
            <b-card no-body style="overflow: visible !important;">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.accordion-2 id='search-bar' class="light-blue text-left text-black" @click="changeIcon(2)"><b-icon id="icon-up_2" icon="chevron-up"></b-icon><b-icon id="icon-down_2" class="hide" icon="chevron-down"></b-icon>&nbsp;検索条件</b-button>
              </b-card-header>
              <!-- 案件検索BOX -->
              <b-collapse visible id="accordion-2" accordion="my-accordion2" role="tabpane2">
                <b-card-body>
                  <form method="post" action="#" class="form-horizontal">
                    <div class="form-group row">
                      <div class="col-sm-2">
                        <label for="project-number" class="control-label col-sm-12">ID</label>
                        <div class="col-sm-12 pr-0">
                          <input type="text" id="project-number" class="form-control input-sm search-spec-condition" v-model="searchProjectNumber"/>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <label for="style" class="control-label col-sm-12">スタイル</label>
                        <div class="col-sm-12 px-0">
                          <div class="col-sm-12 pr-0">
                            <v-select id="style" v-model="searchStyle" label="label" :options="styleData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="styleData.length <= 0"></v-select>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3 row">
                        <label for="spec-facility" class="control-label col-sm-12">撮影施設</label>
                        <div class="col-sm-12 px-0">
                          <div class="col-sm-12 pr-0">
                            <v-select id="spec-facility" v-model="searchSpecFacilityCode" label="label" :options="searchSpecFacilityData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="searchSpecFacilityData.length <= 0"></v-select>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-2">
                        <label for="color" class="control-label col-sm-12">色</label>
                        <div class="col-sm-12 px-0">
                          <div class="col-sm-12 pr-0">
                            <v-select id="color" v-model="searchColor" label="label" :options="colorData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="colorData.length <= 0"></v-select>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-2">
                        <label for="season" class="control-label col-sm-12">季節</label>
                        <div class="col-sm-12 px-0">
                          <div class="col-sm-12 pr-0">
                            <v-select id="season" v-model="searchSeason" label="label" :options="seasonData" :reduce="options => options.value" :close-on-select="false" :deselectFromDropdown="true" multiple :loading="seasonData.length <= 0"></v-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 pr-0">
                        <label for="mainShape" class="control-label col-sm-12">メイン形状</label>
                        <div class="col-sm-12 pr-0">
                          <v-select id="mainShape" class="input-sm search-spec-condition" v-model="searchMainShape" :options="mainShapeData" :reduce="options => options.value" name="mainShape" :close-on-select="false" :deselectFromDropdown="true" append-to-body multiple>
                          </v-select>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <label for="guestShape" class="control-label col-sm-12">ゲスト形状</label>
                        <div class="col-sm-12 pr-0">
                          <v-select id="guestShape" class="input-sm search-spec-condition" v-model="searchGuestShape" :options="guestShapeData" :reduce="options => options.value" name="guestShape" :close-on-select="false" :deselectFromDropdown="true" append-to-body multiple>
                          </v-select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4 pr-0">
                        <div class="row" style="margin-left: 0px">
                          <label class="control-label col-sm-12">メインテーブル合計金額</label>
                          <div class="col-sm-5 pr-0">
                            <input type="text" id="main-price-from" class="form-control input-sm search-spec-condition" v-model="searchMainPriceFrom"/>
                          </div>
                          <div class="col-sm-1 p-0 mt-2 text-center">
                            <span>〜</span>
                          </div>
                          <div class="col-sm-5 pl-0">
                            <input type="text" id="main-price-to" class="form-control input-sm search-spec-condition" v-model="searchMainPriceTo"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="row" style="margin-left: 0px">
                          <label class="control-label col-sm-12">ゲストテーブル合計金額</label>
                          <div class="col-sm-5 pr-0">
                            <input type="text" id="guest-price-from" class="form-control input-sm search-spec-condition" v-model="searchGuestPriceFrom"/>
                          </div>
                          <div class="col-sm-1 p-0 mt-2 text-center">
                            <span>〜</span>
                          </div>
                          <div class="col-sm-5 pl-0">
                            <input type="text" id="guest-price-to" class="form-control input-sm search-spec-condition" v-model="searchGuestPriceTo"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <label for="name" class="control-label col-sm-12">案件フラグ</label>
                        <div class="col-sm-12 pr-0">
                          <v-select id="ankenFlg" class="input-sm search-spec-condition" label="label" :options="ankenFlgOptions" :reduce="options => options.value" v-model="searchAnkenFlg" name="ankenFlg" :close-on-select="false" :deselectFromDropdown="true" multiple></v-select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-2 pr-0">
                        <label for="name" class="control-label col-sm-12">棚割フラグ</label>
                        <div class="col-sm-12 pr-0">
                          <select id="tanawari" class="form-control input-sm search-spec-condition" v-model="searchTanawari">
                            <option value=""></option>
                            <option v-for="(tanawari, index) in getSetting()" :key="index + 'tanawari'" :value="tanawari">{{tanawari}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-2 pr-0">
                        <label for="name" class="control-label col-sm-12">注力フラグ</label>
                        <div class="col-sm-12 pr-0">
                          <select id="tyuryoku" class="form-control input-sm search-spec-condition" v-model="searchTyuryoku">
                            <option value=""></option>
                            <option v-for="(tyuryoku, index) in getSetting()" :key="index + 'tyuryoku'" :value="tyuryoku">{{tyuryoku}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-2">
                        <label for="name" class="control-label col-sm-12">販売目標</label>
                        <div class="col-sm-12 pr-0">
                          <select id="goalset" class="form-control input-sm search-spec-condition" v-model="searchGoalset">
                            <option value=""></option>
                            <option v-for="(goalset, index) in getSetting()" :key="index + 'goalset'" :value="goalset">{{goalset}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="text-center mt-4">
                      <b-button variant="outline-secondary" type="button" class="w-25 white-btn" @click="clearConditions">検索条件をクリア</b-button>
                      <b-button class="main-color text-light w-25 ml-3" @click="searchSpec()">検索</b-button>
                    </div>
                  </form>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>

        <!-- スペック一覧リスト -->
        <div class="row mt-3 base-color">
          <b-overlay :show="overlaySpecListShow" rounded="sm" class="col-sm-12">
            <div class="col-sm-12 row pt-3 pr-0">
              <div class="col-sm-6">
                検索結果<span class="h3 ml-1">{{this.projectLength}}</span><span class="ml-1 mr-2">件</span>{{projectLength > 0 ? pageStart + 1 : 0}} - {{pageEnd}}件を表示
              </div>
              <div class="col-sm-6 text-right pr-0">
                <b-button variant="primary" @click="goalRegist()" :disabled="!savePossible">保存</b-button>
              </div>
            </div>
            <div class="col-sm-12 mt-3">
              <b-table-simple bordered class="small">
                <thead role="rowgroup" class="table-bordered">
                  <tr role="row" class="align-middle">
                    <th rowspan="2" class="align-middle text-center" style="width: 5%;" @click="sortBy('レコード番号', 'num')">ID{{strSortDirection('レコード番号')}}</th>
                    <th rowspan="2" class="align-middle text-center" style="width: 12%;">画像</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 10%;" @click="sortBy('スタイル')">スタイル{{strSortDirection('スタイル')}}</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 14%;" @click="sortBy('メイン形状')">メイン形状{{strSortDirection('メイン形状')}}</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 13%;" @click="sortBy('メインテーブル合計金額', 'num')">メイン金額{{strSortDirection('メインテーブル合計金額')}}</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 10%;" @click="sortBy('色')">色{{strSortDirection('色')}}</th>
                    <th rowspan="2" class="align-middle text-center" style="width: 10%;" @click="sortBy('棚割設定Check', 'novalue')">棚割設定{{strSortDirection('棚割設定Check')}}</th>
                    <th rowspan="2" class="align-middle text-center" style="width: 10%;" @click="sortBy('注力設定Check', 'novalue')">注力商品{{strSortDirection('注力設定Check')}}</th>
                    <th rowspan="2" class="align-middle text-center" style="width: 8%;" @click="sortBy('表示順', 'novaluenum')">表示順{{strSortDirection('表示順')}}</th>
                    <th rowspan="2" class="align-middle text-center" style="width: 8%;" @click="sortBy('販売目標', 'novaluenum')">販売目標{{strSortDirection('販売目標')}}</th>
                  </tr>
                  <tr>
                    <th class="align-middle text-center" @click="sortBy('施設コード')">施設{{strSortDirection('施設コード')}}</th>
                    <th class="align-middle text-center" @click="sortBy('ゲスト形状')">ゲスト形状{{strSortDirection('ゲスト形状')}}</th>
                    <th class="align-middle text-center" @click="sortBy('ゲストテーブル合計金額', 'num')">ゲスト金額{{strSortDirection('ゲストテーブル合計金額')}}</th>
                    <th class="align-middle text-center" @click="sortBy('季節')">季節{{strSortDirection('季節')}}</th>
                  </tr>
                </thead>
                <template v-for="(project, index) in activeProjectList">
                  <b-tbody :key="index + 'tbody'" :class="index % 2 === 1 ? 'gray-line' : 'white-line'">
                    <b-tr :key="index + 'activeProject'">
                      <b-td :rowspan="2" class="align-middle" style="text-align: center;">
                        {{project['レコード番号'] ? project['レコード番号']['value'] : ''}}
                      </b-td>
                      <b-td :rowspan="2" class="align-middle" style="text-align: right;">
                        <b-button class="image-box" @click="handleOpenDialog(project['画像ファイルパス']['value'])">
                          <img :src="project['画像ファイルパス']['value']" class="mw-100 tile-image-height" v-if="project['画像ファイルパス']['value'] !== ''">
                        </b-button>
                      </b-td>
                      <b-td class="align-middle">{{project['スタイル'] ? changeArrayFormat(project['スタイル']['value']) : ''}}</b-td>
                      <b-td class="align-middle" style="white-space: pre-wrap;">{{project['メイン形状'] ? changeToShapeName(project['メイン形状']['value'], 'main') : ''}}</b-td>
                      <b-td class="align-middle" style="text-align: right;">{{project['メインテーブル合計金額'] ? toCommaSeparated(project['メインテーブル合計金額']['value']) : '0'}}</b-td>
                      <b-td class="align-middle">{{project['色'] ? changeArrayFormat(project['色']['value']) : ''}}</b-td>
                      <b-td :rowspan="2" class="align-middle">
                        <div class="custom-control custom-switch text-center ml-2">
                          <input type="checkbox" class="custom-control-input" :id="'toggle-display' + index" :checked="project['棚割設定Check']" @change="changeToggle(index)" :disabled="!savePossible">
                          <label class="custom-control-label" :for="'toggle-display' + index"></label>
                        </div>
                      </b-td>
                      <b-td :rowspan="2" :class="savePossible ? 'align-middle' : 'align-middle no-pointer-events'">
                        <div class="pl-0 custom-control text-center star">
                          <input :id="'star_' + index" type="checkbox" :name="'star' + index" :checked="project['注力設定Check']" @change="changeStar(index)" :disabled="!savePossible"><label :for="'star_' + index">★</label>
                        </div>
                      </b-td>
                      <b-td :rowspan="2"  class="align-middle">
                        <input name="order" type="number" step="0.01" id="order" class="form-control input-sm meeting-input no-spin" v-model="project['表示順']" @change="setRowEdit(index)" :disabled="!savePossible"/>
                      </b-td>
                      <b-td :rowspan="2"  class="align-middle">
                        <input name="goal" type="number" id="goal" class="form-control input-sm meeting-input no-spin" v-model="project['販売目標']" @change="setRowEdit(index)" :disabled="!savePossible"/>
                      </b-td>
                    </b-tr>
                    <b-tr :key="index">
                      <b-td class="align-middle">{{project['施設コード'] ? project['施設コード']['value'] : ''}}<br>{{project['施設名'] ? project['施設名']['value'] : ''}}</b-td>
                      <b-td class="align-middle" style="white-space: pre-wrap;">{{project['ゲスト形状'] ? changeToShapeName(project['ゲスト形状']['value'], 'guest') : ''}}</b-td>
                      <b-td class="align-middle" style="text-align: right;">{{project['ゲストテーブル合計金額'] ? toCommaSeparated(project['ゲストテーブル合計金額']['value']) : '0'}}</b-td>
                      <b-td class="align-middle">{{project['季節'] ? project['季節']['value'] : ''}}</b-td>
                    </b-tr>
                  </b-tbody>
                </template>
              </b-table-simple>
            </div>
          </b-overlay>
        </div>

      </div>
    </b-overlay>
    <dialog ref="dialog" class="image-dialog" @click="handleCloseDialog">
      <div class="contents">
        <img :src="dialogImage" width="300" />
      </div>
    </dialog>
    <CommonModal ref="commonModal" />
    <CommonModal ref="commonModalUpdateCancel" @confirmOk="specUpdateCancel" />
  </ControlCommonLayout>
</template>
<script>
import ControlCommonLayout from '@/layout/ControlCommonLayout'
import CommonModal from '@/components/CommonModal'
// SpecListModelは将来的に消しておきたい。
import SpecListModel from '@/models/SpecListModel'
import SearchSpecFocusPlanModel from '@/models/SearchSpecFocusPlanModel'
import SearchFocusPlanModel from '@/models/SearchFocusPlanModel'
import AreaListModel from '@/models/AreaListModel'
import UnitListModel from '@/models/UnitListModel'
import FacilityListModel from '@/models/FacilityListModel'
import PeriodListModel from '@/models/PeriodListModel'
import FocusPlanRegistModel from '@/models/FocusPlanRegistModel'
import FocusTableNumberRegistModel from '@/models/FocusTableNumberRegistModel'
import Vue from 'vue'
import Paginate from 'vuejs-paginate'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
Vue.component('paginate', Paginate)
Vue.component('v-select', vSelect)

export default {
  name: 'FocusSpecList',
  components: { ControlCommonLayout, CommonModal, SpecListModel, SearchSpecFocusPlanModel, SearchFocusPlanModel, AreaListModel, UnitListModel, FacilityListModel, PeriodListModel, FocusPlanRegistModel, FocusTableNumberRegistModel },
  data () {
    return {
      overlayShow: false,
      overlayPlanListShow: false,
      overlaySpecListShow: false,
      searchProjectNumber: '',
      searchStyle: [],
      searchColor: [],
      searchSeason: [],
      searchMainPriceFrom: '',
      searchMainPriceTo: '',
      searchGuestPriceFrom: '',
      searchGuestPriceTo: '',
      searchMainShape: [],
      searchGuestShape: [],
      searchAnkenFlg: ['1', '3', '1.5'],
      searchTanawari: '',
      searchTyuryoku: '',
      searchGoalset: '',
      searchSpecFacilityData: [],
      searchSpecFacilityCode: [],
      styleData: [],
      colorData: [],
      seasonData: [],
      mainShapeData: [],
      guestShapeData: [],

      userId: '',
      userRole: '',
      userRoleMode: '',
      userArea: '',
      userUnit: '',

      activeProjectList: [],
      projectData: [],
      projectDataBk: [],
      projectLength: 0,
      page: 1,
      pageMaxNum: 20,
      pageStart: 0,
      pageEnd: 0,
      SortDirection: {},
      ankenFlgOptions: [{'label': '１：本部企画', 'value': '1'}, {'label': '１.５：エリア企画', 'value': '1.5'}, {'label': '３：施工画像', 'value': '3'}, {'label': '６：施設特有', 'value': '6'}, {'label': '７：納品画像商品', 'value': '7'}],

      selectAllText: 'すべて',
      areaData: [],
      unitData: [],
      facilityData: [],
      periodData: [],
      searchAreaName: [],
      searchUnitName: [],
      searchFacilityCode: [],
      searchPeriod: [],
      searchDataSetFlg: false,

      nowSearchAreaName: [],
      nowSearchUnitName: [],
      nowSearchFacilityCode: [],
      nowSearchPeriod: [],
      nowAreaData: [],
      nowUnitData: [],
      nowFacilityData: [],
      nowPeriodData: [],
      savePossible: false,

      goalData: {},

      dialogImage: '',
      tableNumber: ''
    }
  },
  methods: {
    setApiData: async function (isReload = false) {
      this.overlayShow = true
      console.log(this.$route.meta)
      console.log(this.$route.query)
      const dataKeepFlag = JSON.parse(sessionStorage.getItem('dataKeepFlag'))
      console.log(dataKeepFlag)
      if (this.$route.meta.userId && dataKeepFlag !== true) {
        console.log('初期化処理')
        this.userId = this.$route.meta.userId
        localStorage.setItem('specGoalUserId', this.userId)

        // エリア、ユニット、施設、期、適用、卓数データの初期化
        localStorage.setItem('specGoalSearchAreaName', this.searchAreaName)
        localStorage.setItem('specGoalSearchUnitName', this.searchUnitName)
        localStorage.setItem('specGoalSearchFacilityCode', this.searchFacilityCode)
        localStorage.setItem('specGoalSearchPeriod', this.searchPeriod)
        localStorage.setItem('specGoalGoalData', this.goalData)
        localStorage.setItem('specGoalTableNumber', this.tableNumber)
      } else {
        this.userId = localStorage.getItem('specGoalUserId')
        this.userRole = localStorage.getItem('specGoalUserRole')
        this.userArea = localStorage.getItem('specGoalUserArea')
        this.userUnit = localStorage.getItem('specGoalUserUnit')
      }
      console.log(this.userId)

      // 保存ボタンの活性判定
      if (localStorage.getItem('specGoalSearchFacilityCode') && !localStorage.getItem('specGoalSearchFacilityCode').includes(',') && localStorage.getItem('specGoalSearchFacilityCode') !== '0' && localStorage.getItem('specGoalSearchPeriod') && !localStorage.getItem('specGoalSearchPeriod').includes(',') && localStorage.getItem('specGoalSearchPeriod') !== '0') {
        this.savePossible = true
      }

      const result = await SpecListModel.getApi(this.$bvModal, null, () => {})
      console.log(result)
      if (result['style'] === undefined) {
        console.log('style:undefined')
      } else {
        this.styleData = result['style']
        let styles = result['style']
        this.styleData = []
        if (!styles) {
          this.styleData.push({ 'label': '', 'value': '' })
          return
        }
        for (let i = 0; i < styles.length; i++) {
          this.styleData.push({ 'label': styles[i]['スタイル'].value, 'value': this.styleData.length, 'searchValue': styles[i]['スタイル'].value })
        }
      }
      if (result['color'] === undefined) {
        console.log('color:undefined')
      } else {
        let colors = result['color']
        this.colorData = []
        if (!colors) {
          this.colorData.push({ 'label': '', 'value': '' })
          return
        }
        for (let i = 0; i < colors.length; i++) {
          this.colorData.push({ 'label': colors[i]['名称'].value, 'value': this.colorData.length, 'searchValue': colors[i]['名称'].value })
        }
      }
      if (result['season'] === undefined) {
        console.log('season:undefined')
      } else {
        let seasons = result['season']
        this.seasonData = []
        if (!seasons) {
          this.seasonData.push({ 'label': '', 'value': '' })
          return
        }
        for (let i = 0; i < seasons.length; i++) {
          this.seasonData.push({ 'label': seasons[i]['名称'].value, 'value': this.seasonData.length, 'searchValue': seasons[i]['名称'].value })
        }
      }
      if (result['tantosha'] === undefined) {
        console.log('tantosha:undefined')
      } else {
        for (const tantosha of result['tantosha']) {
          if (this.userId === tantosha['担当者コード']['value']) {
            this.userRole = tantosha['役割']['value']
            localStorage.setItem('specGoalUserRole', this.userRole)
            this.userArea = tantosha['所属エリア']['value']
            localStorage.setItem('specGoalUserArea', this.userArea)
            this.userUnit = tantosha['所属ユニット']['value']
            localStorage.setItem('specGoalUserUnit', this.userUnit)
            break
          }
        }
      }
      if (result['mainShape'] === undefined) {
        console.log('mainShape:undefined')
      } else {
        this.mainShapeData = result['mainShape']
      }
      if (result['guestShape'] === undefined) {
        console.log('guestShape:undefined')
      } else {
        this.guestShapeData = result['guestShape']
      }
      console.log(this.userRole)
      console.log(this.userArea)
      console.log(this.userUnit)

      // ユーザーの役割に応じたモード変更
      this.setUserRoleMode()
      console.log(this.userRoleMode)

      // 選択肢の情報を取得
      await this.setSelectItems()

      // 再取得
      if (dataKeepFlag) {
        await this.searchFocusPlan(false, false)
      }

      // 次画面から戻ってきたとき、検索条件の再設定、再検索、ページ移動を行う
      if (JSON.parse(localStorage.getItem('isPageBack'))) {
        console.log('pageback処理')
        await this.pageBackDataSetUp()
        if (localStorage.getItem('nowProjectListPage')) {
          // ページ番号があるとき（１回でも検索していた時）再検索を行う
          this.page = parseInt(localStorage.getItem('nowProjectListPage'), 10)
          this.searchSpec(this.page, true)
        }
        localStorage.removeItem('isPageBack')
      } else {
        scrollTo(0, 0)
        // 初期表示時、退避させていた入力情報を消す
        localStorage.removeItem('searchSpecConditions')
        localStorage.removeItem('nowProjectListPage')
      }

      this.overlayShow = false
    },
    toCommaSeparated (str) {
      if (str) {
        try {
          return parseInt(str, 10).toLocaleString()
        } catch (err) {
          return ''
        }
      }
      return str
    },
    changeDateFormat (date, type = '') {
      if (date === null) {
        return null
      }
      if (type === 'constructionDate') {
        date = date.replace('-', '/').replace('-', '/')
      } else {
        date = date.substring(0, date.indexOf('T')).replace('-', '/').replace('-', '/')
      }
      return date
    },
    changeArrayFormat (date) {
      if (date === null) {
        return null
      }

      return date.join('、')
    },
    changeIcon (num) {
      document.getElementById('icon-up_' + num).classList.toggle('hide')
      document.getElementById('icon-down_' + num).classList.toggle('hide')
    },
    getDisplay () {
      return ['表示', '非表示']
    },
    getSetting () {
      return ['設定', '未設定']
    },
    validate () {
      // 検索条件のチェックを追加する
      return true
    },
    isDecimal (val) {
      return new RegExp(/^([1-9]\d*|0)(\.\d{1,2})?$/).test(val)
    },
    clearConditions () {
      this.searchProjectNumber = ''
      this.searchStyle = []
      this.searchColor = []
      this.searchSeason = []
      this.searchMainPriceFrom = ''
      this.searchMainPriceTo = ''
      this.searchGuestPriceFrom = ''
      this.searchGuestPriceTo = ''
      this.searchSpecFacilityCode = []
      this.searchMainShape = []
      this.searchGuestShape = []
      this.searchAnkenFlg = ['1', '3', '1.5']
      this.searchTanawari = ''
      this.searchTyuryoku = ''
      this.searchGoalset = ''
    },
    resetProjects () {
      this.projectData = []
      this.projectLength = 0
      this.pageStart = 0
      this.pageEnd = 0
    },
    searchFocusPlan: async function (isPageBack = false, searchAgain = false) {
      // 前画面から戻った時でなければ画面入力値のチェックを行う
      if (!isPageBack) {
        if (!this.validate()) {
          return false
        }
      }
      this.overlaySpecListShow = true
      this.overlayPlanListShow = true

      let params = {}

      if (searchAgain) {
        console.log('再検索')
        params['searchAreaName'] = this.nowSearchAreaName
        params['areaName'] = this.getSelectListDict(this.getSearchSelect(this.nowSearchAreaName, this.nowAreaData))
        params['searchUnitName'] = this.nowSearchUnitName
        params['unitName'] = this.getSelectListDict(this.getSearchSelect(this.nowSearchUnitName, this.nowUnitData))
        params['searchFacilityCode'] = this.nowSearchFacilityCode
        params['facilityCode'] = this.getSelectListDict(this.getSearchSelect(this.nowSearchFacilityCode, this.nowFacilityData))
        params['searchPeriod'] = this.nowSearchPeriod
        params['period'] = this.getSelectListDict(this.getSearchSelect(this.nowSearchPeriod, this.nowPeriodData))
      } else {
        console.log('検索')
        params['searchAreaName'] = this.searchAreaName
        params['areaName'] = this.getSelectListDict(this.getSearchSelect(this.searchAreaName, this.areaData))
        params['searchUnitName'] = this.searchUnitName
        params['unitName'] = this.getSelectListDict(this.getSearchSelect(this.searchUnitName, this.unitData))
        params['searchFacilityCode'] = this.searchFacilityCode
        params['facilityCode'] = this.getSelectListDict(this.getSearchSelect(this.searchFacilityCode, this.facilityData))
        params['searchPeriod'] = this.searchPeriod
        params['period'] = this.getSelectListDict(this.getSearchSelect(this.searchPeriod, this.periodData))
      }

      // 権限に応じた検索条件の追加
      if (this.userRoleMode === 1 || this.userRoleMode === 2) {
        params['userArea'] = this.userArea
      }
      if (this.userRoleMode === 2) {
        params['userUnit'] = this.userUnit
      }

      let goalsData = await SearchFocusPlanModel.getApi(this.$bvModal, params, () => {})
      console.log(goalsData)
      if (!goalsData['goals'] || goalsData['status'] !== 'success') {
        console.log('注力策定情報検索失敗')
        this.$refs.commonModal.msgBoxOk('注力策定情報の検索に失敗いたしました。')
        this.overlaySpecListShow = false
        return false
      }

      // データセット
      this.goalData = goalsData['goals']
      this.tableNumber = goalsData['goals']['ゲストテーブル卓数']

      this.savePossible = false
      if (searchAgain) {
        if (this.nowSearchFacilityCode.length === 1 && this.nowSearchFacilityCode[0] !== 0 && this.nowSearchPeriod.length === 1 && this.nowSearchPeriod[0] !== 0) {
          this.savePossible = true
        }
      } else {
        // エリア、ユニット、施設、期、適用、卓数データの保存
        localStorage.setItem('specGoalSearchAreaName', this.searchAreaName)
        localStorage.setItem('specGoalSearchUnitName', this.searchUnitName)
        localStorage.setItem('specGoalSearchFacilityCode', this.searchFacilityCode)
        localStorage.setItem('specGoalSearchPeriod', this.searchPeriod)
        localStorage.setItem('specGoalGoalData', JSON.stringify(this.goalData))
        localStorage.setItem('specGoalTableNumber', this.tableNumber)

        if (this.searchFacilityCode.length === 1 && this.searchFacilityCode[0] !== 0 && this.searchPeriod.length === 1 && this.searchPeriod[0] !== 0) {
          this.savePossible = true
        }
        this.nowSearchAreaName = this.searchAreaName
        this.nowSearchUnitName = this.searchUnitName
        this.nowSearchFacilityCode = this.searchFacilityCode
        this.nowSearchPeriod = this.searchPeriod
        this.nowAreaData = this.areaData
        this.nowUnitData = this.unitData
        this.nowFacilityData = this.facilityData
        this.nowPeriodData = this.periodData
        // 画面に表示している一覧をクリア
        this.activeProjectList = []
        // 検索結果を初期化
        this.resetProjects()
        // 1ページ目を表示
        this.page = 1
      }

      this.overlaySpecListShow = false
      this.overlayPlanListShow = false
    },
    searchSpec: async function (nowpage = 1, isPageBack = false) {
      // 前画面から戻った時でなければ画面入力値のチェックを行う
      if (!isPageBack) {
        if (!this.validate()) {
          return false
        }
      }
      this.page = nowpage
      this.overlaySpecListShow = true

      // 入力値変換
      this.searchMainPriceFrom = this.searchMainPriceFrom.replace(',', '').replace(' ', '')
      this.searchMainPriceTo = this.searchMainPriceTo.replace(',', '').replace(' ', '')
      this.searchGuestPriceFrom = this.searchGuestPriceFrom.replace(',', '').replace(' ', '')
      this.searchGuestPriceTo = this.searchGuestPriceTo.replace(',', '').replace(' ', '')
      this.searchProjectNumber = this.searchProjectNumber.replace('，', ',')

      let params = {}
      if (this.searchProjectNumber !== '') {
        params['projectNumber'] = this.searchProjectNumber.split(',')
      }
      if (this.searchStyle !== []) {
        params['selectStyle'] = this.getSelectListDict(this.getSearchSelect(this.searchStyle, this.styleData))
      }
      if (this.searchColor !== []) {
        params['selectColor'] = this.getSelectListDict(this.getSearchSelect(this.searchColor, this.colorData))
      }
      if (this.searchSeason !== []) {
        params['selectSeason'] = this.getSelectListDict(this.getSearchSelect(this.searchSeason, this.seasonData))
      }
      if (this.searchMainPriceFrom !== '') {
        params['mainPriceFrom'] = this.searchMainPriceFrom
      }
      if (this.searchMainPriceTo !== '') {
        params['mainPriceTo'] = this.searchMainPriceTo
      }
      if (this.searchGuestPriceFrom !== '') {
        params['guestPriceFrom'] = this.searchGuestPriceFrom
      }
      if (this.searchGuestPriceTo !== '') {
        params['guestPriceTo'] = this.searchGuestPriceTo
      }
      if (this.searchMainShape.length > 0) {
        params['mainShape'] = this.searchMainShape
      }
      if (this.searchGuestShape.length > 0) {
        params['guestShape'] = this.searchGuestShape
      }
      if (this.searchAnkenFlg.length > 0) {
        params['ankenFlg'] = this.searchAnkenFlg
      }
      if (this.searchTyuryoku !== '') {
        params['tyuryoku'] = this.searchTyuryoku
      }
      if (this.searchTanawari !== '') {
        params['tanawari'] = this.searchTanawari
      }
      if (this.searchGoalset !== '') {
        params['goalset'] = this.searchGoalset
      }
      if (this.searchSpecFacilityCode !== []) {
        params['selectFacilityCode'] = this.getSelectListDict(this.getSearchSelect(this.searchSpecFacilityCode, this.searchSpecFacilityData))
      }

      params['searchAreaName'] = this.searchAreaName
      params['areaName'] = this.getSelectListDict(this.getSearchSelect(this.nowSearchAreaName, this.nowAreaData))
      params['searchUnitName'] = this.searchUnitName
      params['unitName'] = this.getSelectListDict(this.getSearchSelect(this.nowSearchUnitName, this.nowUnitData))
      params['searchFacilityCode'] = this.searchFacilityCode
      params['facilityCode'] = this.getSelectListDict(this.getSearchSelect(this.nowSearchFacilityCode, this.nowFacilityData))
      params['searchPeriod'] = this.searchPeriod
      params['period'] = this.getSelectListDict(this.getSearchSelect(this.nowSearchPeriod, this.nowPeriodData))

      // 権限に応じた検索条件の追加
      if (this.userRoleMode === 1 || this.userRoleMode === 2) {
        params['userArea'] = this.userArea
      }
      if (this.userRoleMode === 2) {
        params['userUnit'] = this.userUnit
      }

      let projectData = await SearchSpecFocusPlanModel.getApi(this.$bvModal, params, () => {})
      console.log(projectData)
      if (!projectData['specs'] || !projectData['specs']['records'] || projectData['status'] !== 'success') {
        console.log('スペック情報検索失敗')
        this.$refs.commonModal.msgBoxOk('スペック情報の検索に失敗いたしました。')
        this.overlaySpecListShow = false
        return false
      }
      this.projectData = projectData['specs']['records']

      // 検索条件を保存
      let searchSpecConditions = {}
      this.projectLength = projectData['specs']['records'].length

      // 画面項目の検索条件を保存
      if (!isPageBack) {
        const searchInputs = document.getElementsByClassName('search-spec-condition')
        for (const searchInput of searchInputs) {
          if (searchInput.id === 'selectFacilityCode') {
            searchSpecConditions[searchInput.id] = this.searchSpecFacilityCode
          } else if (searchInput.id === 'searchStyle') {
            searchSpecConditions[searchInput.id] = this.searchStyle
          } else if (searchInput.id === 'selectColor') {
            searchSpecConditions[searchInput.id] = this.searchColor
          } else if (searchInput.id === 'selectSeason') {
            searchSpecConditions[searchInput.id] = this.searchSeason
          } else if (searchInput.id === 'mainShape') {
            searchSpecConditions[searchInput.id] = this.searchMainShape
          } else if (searchInput.id === 'guestShape') {
            searchSpecConditions[searchInput.id] = this.searchGuestShape
          } else if (searchInput.id === 'ankenFlg') {
            searchSpecConditions[searchInput.id] = this.searchAnkenFlg
          } else {
            searchSpecConditions[searchInput.id] = searchInput.value
          }
        }
        localStorage.setItem('searchSpecConditions', JSON.stringify(searchSpecConditions))
        // 1page目を表示
        await this.movePage(1)
      }

      // バックアップはソートなしの状態として保存
      this.projectDataBk = []
      for (let i = 0; i < this.projectData.length; i++) {
        let defdata = Object.assign({}, this.projectData[i])
        this.projectDataBk.push(defdata)
      }

      // 画面のソート状態でソート
      await this.sortKeep()

      // トグルの初期化
      this.refreshToggel()

      this.overlaySpecListShow = false
    },
    movePage (pageNum) {
      this.page = pageNum
      this.setActiveViewList()
    },
    onScroll: async function () {
      const bottomPosition = document.body.offsetHeight - (window.scrollY + window.innerHeight)
      if (bottomPosition < 56 && !this.overlayShow && this.projectLength > this.activeProjectList.length) {
        this.overlayShow = true
        await this.movePage(this.page + 1)
        this.overlayShow = false
      }
    },
    setActiveViewList () {
      this.pageEnd = (this.page - 1) * this.pageMaxNum + this.pageMaxNum
      if (this.projectLength < this.pageEnd) {
        this.pageEnd = (this.page - 1) * this.pageMaxNum + (this.projectLength % this.pageMaxNum)
      }
      this.activeProjectList = this.projectData.slice(this.pageStart, this.pageEnd)
    },
    goInventorySpecList () {
      sessionStorage.setItem('dataKeepFlag', true)
      this.$router.push({
        name: 'InventorySpecList',
        query: {}
      })
    },
    changeToggle (index) {
      if (this.activeProjectList[index]['棚割設定Check']) {
        this.activeProjectList[index]['棚割設定Check'] = false
        document.getElementById('toggle-display' + index).checked = false
        this.activeProjectList[index]['注力設定Check'] = false
      } else {
        this.activeProjectList[index]['棚割設定Check'] = true
        document.getElementById('toggle-display' + index).checked = true
      }
      // 編集フラグを立てる
      this.setRowEdit(index)
    },
    changeStar (index) {
      if (this.activeProjectList[index]['注力設定Check']) {
        this.activeProjectList[index]['注力設定Check'] = false
      } else {
        this.activeProjectList[index]['注力設定Check'] = true
        this.activeProjectList[index]['棚割設定Check'] = true
        document.getElementById('toggle-display' + index).checked = true
      }
      // 編集フラグを立てる
      this.setRowEdit(index)
    },

    goalRegist: async function () {
      // 画面入力値のチェックを行う
      // if (!this.validate()) {
      //  return false
      // }
      this.overlayShow = true

      // 保存データ
      const registData = {
        'facilityCode': this.getSelectListDict(this.getSearchSelect(this.nowSearchFacilityCode, this.nowFacilityData)),
        'period': this.getSelectListDict(this.getSearchSelect(this.nowSearchPeriod, this.nowPeriodData)),
        'registsData': []
      }

      for (let i = 0; i < this.projectData.length; i++) {
        if (!this.projectData[i]['edit']) {
          // 編集行でなければ飛ばす
          continue
        }

        let addData = {
          'value': {
            'スペック商品ID': {'value': this.projectData[i]['レコード番号']['value']},
            'スタイル': {'value': (this.projectData[i]['スタイル']['value'].length > 0 ? this.projectData[i]['スタイル']['value'][0] : '')},
            'メインテーブル合計金額': {'value': this.projectData[i]['メインテーブル合計金額']['value']},
            'ゲストテーブル合計金額': {'value': this.projectData[i]['ゲストテーブル合計金額']['value']},
            '棚割設定': {'value': (this.projectData[i]['棚割設定Check'] ? ['設定'] : [])},
            '注力設定': {'value': (this.projectData[i]['注力設定Check'] ? ['設定'] : [])},
            '表示順': {'value': this.projectData[i]['表示順'] !== '' && this.projectData[i]['表示順'] !== '0' ? this.projectData[i]['表示順'] : 99998},
            '販売目標': {'value': this.projectData[i]['販売目標']}
          }
        }

        registData['registsData'].push(addData)
      }

      console.log(registData)

      // 更新処理
      await FocusPlanRegistModel.postApi(this.$bvModal, registData, (result) => {
      },
      () => {
      })

      // 現在のデータをBkに置き換える
      for (let i = 0; i < this.projectData.length; i++) {
        if (!this.projectData[i]['edit']) {
          // 編集行でなければ飛ばす
          continue
        }
        this.projectDataBk[this.projectData[i]['No']] = Object.assign({}, this.projectData[i])
        this.projectData[i]['edit'] = false
      }
      // 再検索処理
      await this.searchFocusPlan(false, true)
      this.$refs.commonModal.msgBoxOk('注力商品情報を更新いたしました。')
      this.overlayShow = false
      return true
    },
    specUpdate: async function (projectNumber, updateStatus) {
      let param = {'projectNumber': projectNumber}
      param['案件ステータス'] = {'value': updateStatus}
      const result = await SpecListModel.postApi(this.$bvModal, param, () => {})
      console.log(result)
      if (result['status'] !== 'success') {
        console.log('スペック情報更新失敗')
      } else {
        // 画面に表示されている一覧を検索した時の入力値に戻して再検索
        // await this.pageBackDataSetUp()
        // this.searchSpec(this.page, false)
      }
    },
    refreshToggel () {
      for (let i = 0; i < this.activeProjectList.length; ++i) {
        let toggle = document.getElementById('toggle-display' + i)
        if (toggle) {
          toggle.checked = (this.activeProjectList[i]['棚割設定Check'])
        }
      }
    },
    pageBackDataSetUp: async function () {
      const searchSpecConditions = JSON.parse(localStorage.getItem('searchSpecConditions'))
      console.log(searchSpecConditions)
      if (searchSpecConditions) {
        for (const [key, value] of Object.entries(searchSpecConditions)) {
          if (key === 'project-number') {
            this.searchProjectNumber = value.trim()
          } else if (key === 'selectStyle') {
            this.searchStyle = value
          } else if (key === 'selectColor') {
            this.searchColor = value
          } else if (key === 'selectSeason') {
            this.searchSeason = value
          } else if (key === 'main-price-from') {
            this.searchMainPriceFrom = value
          } else if (key === 'main-price-to') {
            this.searchMainPriceTo = value
          } else if (key === 'guest-price-from') {
            this.searchGuestPriceFrom = value
          } else if (key === 'guest-price-to') {
            this.searchGuestPriceTo = value
          } else if (key === 'mainShape') {
            this.searchMainShape = value
          } else if (key === 'guestShape') {
            this.searchGuestShape = value
          } else if (key === 'ankenFlg') {
            this.searchAnkenFlg = value
          } else if (key === 'selectFacilityCode') {
            this.searchSpecFacilityCode = value
          } else if (key === 'tanawari') {
            this.searchTanawari = value
          } else if (key === 'tyuryoku') {
            this.searchTyuryoku = value
          } else if (key === 'goalset') {
            this.searchGoalset = value
          }
        }
      }
    },

    sortBy (key, type = 'str') {
      this.iniSortDirection(key)
      this.sortSet(key, this.getSortDirection(key), type)
    },
    sortSet (key, sortType = 'asc', type = 'str') {
      this.overlaySpecListShow = true

      if (sortType !== '') {
        let ProjectList = this.projectData
        console.log(ProjectList)
        if (key === '表示順') {
          // 表示順が0または空のデータは99998に変換する
          for (let i = 0; i < ProjectList.length; i++) {
            if (ProjectList[i]['表示順'] === 0) {
              ProjectList[i]['表示順'] = 99998
              ProjectList[i]['元ゼロ'] = true
            }
            if (ProjectList[i]['表示順'] === '') {
              ProjectList[i]['表示順'] = 99998
              ProjectList[i]['元空'] = true
            }
          }
        }
        this.projectData = []
        setTimeout(() => {
          let trueSort = 1 // 降順ソート
          let folseSort = -1 // 降順ソート
          if (sortType !== 'desc') {
            trueSort = -1 // 昇順ソート
            folseSort = 1 // 昇順ソート
          }
          if (type === 'num') {
            ProjectList = ProjectList.sort(function (a, b) {
              return (Number(a[key]['value']) < Number(b[key]['value']) ||
                (Number(a[key]['value']) === Number(b[key]['value']) && Number(a['レコード番号']['value']) < Number(b['レコード番号']['value']))) ? trueSort : folseSort
            })
          } else if (type === 'novaluenum') {
            ProjectList = ProjectList.sort(function (a, b) {
              return (Number(a[key]) < Number(b[key]) ||
                (Number(a[key]) === Number(b[key]) && Number(a['レコード番号']['value']) < Number(b['レコード番号']['value']))) ? trueSort : folseSort
            })
          } else if (type === 'novalue') {
            ProjectList = ProjectList.sort(function (a, b) {
              return (a[key] < b[key] ||
                (a[key] === b[key] && Number(a['レコード番号']['value']) < Number(b['レコード番号']['value']))) ? trueSort : folseSort
            })
          } else {
            ProjectList = ProjectList.sort(function (a, b) {
              return (String(a[key]['value']) < String(b[key]['value']) ||
                (String(a[key]['value']) === String(b[key]['value']) && Number(a['レコード番号']['value']) < Number(b['レコード番号']['value']))) ? trueSort : folseSort
            })
          }
          if (key === '表示順') {
            // 表示順を0と空に戻す
            for (let i = 0; i < ProjectList.length; i++) {
              if (ProjectList[i]['表示順'] === 99998 && '元ゼロ' in ProjectList[i] && ProjectList[i]['元ゼロ'] === true) {
                ProjectList[i]['表示順'] = 0
              }
              if (ProjectList[i]['表示順'] === 99998 && '元空' in ProjectList[i] && ProjectList[i]['元空'] === true) {
                ProjectList[i]['表示順'] = ''
              }
            }
          }
          console.log(ProjectList)
          this.projectData = ProjectList
          this.setActiveViewList()
        }, 100)
      }

      this.overlaySpecListShow = false
    },
    getSortDirection (key) {
      if (this.SortDirection[key] === 'asc') {
        this.SortDirection[key] = 'desc'
        return 'desc'
      } else {
        this.SortDirection[key] = 'asc'
        return 'asc'
      }
    },
    iniSortDirection (key = '') {
      for (const [setKey] of Object.entries(this.SortDirection)) {
        if (key !== setKey) {
          this.SortDirection[setKey] = ''
        }
      }
    },
    strSortDirection (key) {
      let keysort = this.SortDirection[key]
      if (keysort === 'asc') {
        return ' ▲'
      }
      if (keysort === 'desc') {
        return ' ▼'
      }
      return ''
    },
    sortKeep (key) {
      for (const [setKey] of Object.entries(this.SortDirection)) {
        if (this.SortDirection[setKey] !== '') {
          let type = 'str'
          if (setKey === 'レコード番号' ||
            setKey === 'メインテーブル合計金額' ||
            setKey === 'ゲストテーブル合計金額') {
            type = 'num'
          } else if (setKey === '棚割設定Check' ||
            setKey === '注力設定Check') {
            type = 'novalue'
          } else if (setKey === '表示順' ||
            setKey === '販売目標') {
            type = 'novaluenum'
          }
          this.sortSet(setKey, this.SortDirection[setKey], type)
        }
      }
    },

    setUserRoleMode () {
      const roleMode = {
        'システム管理者': 3,
        '運用管理者': 3,
        '本部マネージャー': 3,
        'エリアマネージャー': 1,
        'ユニットリーダー': 1,
        'チームリーダー': 1,
        'メンバー': 1,
        'プランナー': 0,
        'SDP': 2
      }
      this.userRoleMode = (this.userRole in roleMode) ? roleMode[this.userRole] : 0
    },
    changeToShapeName (data, type) {
      let strShapeData = ''
      if (type === 'main') {
        for (const i in this.mainShapeData) {
          if (data.includes('"' + this.mainShapeData[i]['value'] + '"')) {
            strShapeData += this.mainShapeData[i]['label'] + '\n'
          }
        }
        if (strShapeData !== '') {
          strShapeData = strShapeData.slice(0, strShapeData.length - 1)
        }
      } else {
        for (const i in this.guestShapeData) {
          if (data.includes('"' + this.guestShapeData[i]['value'] + '"')) {
            strShapeData += this.guestShapeData[i]['label'] + '\n'
          }
        }
        if (strShapeData !== '') {
          strShapeData = strShapeData.slice(0, strShapeData.length - 1)
        }
      }
      return strShapeData
    },

    setRowEdit (index) {
      // 検索・保存時のデータと入力後のデータを比較する。
      // 一致していなければ編集あり。
      this.activeProjectList[index]['edit'] = false
      let newdata = Object.assign({}, this.projectData[index])
      let olddata = Object.assign({}, this.projectDataBk[this.projectData[index]['No']])
      // 更新時に書き換わる項目を同値にする。
      // この画面では特になし。
      let newstr = JSON.stringify(newdata)
      let oldstr = JSON.stringify(olddata)
      this.activeProjectList[index]['edit'] = (newstr !== oldstr)
      // console.log(this.activeProjectList[index]['edit'])
    },

    handleOpenDialog (imgAddress) {
      if (this.$refs.dialog) {
        this.dialogImage = imgAddress
        this.$refs.dialog.showModal()
      }
    },
    handleCloseDialog () {
      if (this.$refs.dialog) {
        this.$refs.dialog.close()
      }
    },

    setSelectItemsValidate (area = '', unit = '') {
      let areacheck = (area === '' || this.userArea === area)
      let unitcheck = (unit === '' || this.userUnit === unit)
      return (this.userRoleMode === 3 || (this.userRoleMode === 1 && areacheck) || (this.userRoleMode === 2 && areacheck && unitcheck))
    },
    setSelectItems: async function () {
      this.overlayShow = true
      this.searchDataSetFlg = false

      // エリア、ユニット、施設、期、適用データの反映
      if (localStorage.getItem('specGoalSearchAreaName')) {
        try {
          this.searchAreaName = String(localStorage.getItem('specGoalSearchAreaName')).split(',').map(str => parseInt(str, 10))
        } catch (e) {
          this.searchAreaName = []
        }
      }
      if (localStorage.getItem('specGoalSearchUnitName')) {
        try {
          this.searchUnitName = String(localStorage.getItem('specGoalSearchUnitName')).split(',').map(str => parseInt(str, 10))
        } catch (e) {
          this.searchUnitName = []
        }
      }
      if (localStorage.getItem('specGoalSearchFacilityCode')) {
        try {
          this.searchFacilityCode = String(localStorage.getItem('specGoalSearchFacilityCode')).split(',').map(str => parseInt(str, 10))
        } catch (e) {
          this.searchFacilityCode = []
        }
      }
      if (localStorage.getItem('specGoalSearchPeriod')) {
        try {
          this.searchPeriod = String(localStorage.getItem('specGoalSearchPeriod')).split(',').map(str => parseInt(str, 10))
        } catch (e) {
          this.searchPeriod = []
        }
      }
      if (localStorage.getItem('specGoalGoalData')) {
        try {
          this.goalData = JSON.parse(localStorage.getItem('specGoalGoalData'))
        } catch (e) {
          this.goalData = {}
        }
      }
      if (localStorage.getItem('specGoalTableNumber')) {
        try {
          this.tableNumber = JSON.parse(localStorage.getItem('specGoalTableNumber'))
        } catch (e) {
          this.tableNumber = {}
        }
      }

      // プルダウン内容設定
      let areas = (await AreaListModel.getApi(this.$bvModal))['areas']
      this.areaData = []
      if (!areas) {
        this.areaData.push({ 'label': '', 'value': '' })
        return
      }
      this.areaData.push({ 'label': this.selectAllText, 'value': 0, 'searchValue': '' })
      for (let i = 0; i < areas['records'].length; i++) {
        if (this.setSelectItemsValidate(areas['records'][i]['エリア名'].value)) {
          this.areaData.push({ 'label': areas['records'][i]['エリア名'].value, 'value': this.areaData.length, 'searchValue': areas['records'][i]['エリア名'].value })
        }
      }

      let units = (await UnitListModel.getApi(this.$bvModal))['units']
      if (this.searchAreaName.length === 0) {
        this.unitData = []
        if (!units) {
          this.unitData.push({ 'label': '', 'value': '' })
          return
        }
        this.unitData.push({ 'label': this.selectAllText, 'value': 0, 'searchValue': '' })
        for (let i = 0; i < units['records'].length; i++) {
          if (this.setSelectItemsValidate(units['records'][i]['所属エリア'].value, units['records'][i]['ユニット名'].value)) {
            this.unitData.push({ 'label': units['records'][i]['ユニット名'].value, 'value': this.unitData.length, 'searchValue': units['records'][i]['ユニット名'].value })
          }
        }
      } else {
        await this.setUnits()
      }

      let facilities = (await FacilityListModel.getApi(this.$bvModal))['facilities']
      if (this.searchAreaName.length === 0 && this.searchUnitName.length === 0) {
        this.facilityData = []
        if (!facilities) {
          this.facilityData.push({ 'label': '', 'value': '' })
          return
        }
        this.facilityData.push({ 'label': this.selectAllText, 'value': 0, 'searchValue': '' })
        for (let i = 0; i < facilities['records'].length; i++) {
          // ヘッダーの施設
          if (this.setSelectItemsValidate(facilities['records'][i]['担当エリア'].value, facilities['records'][i]['担当ユニット'].value)) {
            this.facilityData.push({ 'label': facilities['records'][i]['施設名'].value, 'value': this.facilityData.length, 'searchValue': facilities['records'][i]['施設コード'].value })
          }
        }
      } else {
        await this.setFacilities()
      }
      this.searchSpecFacilityData = []
      for (let i = 0; i < facilities['records'].length; i++) {
        // 検索条件の施設
        this.searchSpecFacilityData.push({ 'label': facilities['records'][i]['施設名'].value, 'value': this.searchSpecFacilityData.length, 'searchValue': facilities['records'][i]['施設コード'].value })
      }

      let period = (await PeriodListModel.getApi(this.$bvModal))['period']
      let nowperiod = (await PeriodListModel.getApi(this.$bvModal))['nowperiod']

      this.periodData = []
      if (!period) {
        this.periodData.push({ 'label': '', 'value': '' })
        return
      }
      this.periodData.push({ 'label': this.selectAllText, 'value': 0, 'searchValue': '' })
      for (let i = 0; i < period['records'].length; i++) {
        if (nowperiod['期'].value === period['records'][i]['期'].value && this.searchPeriod.length === 0 && this.goalData === {}) {
          this.searchPeriod.push(this.periodData.length)
        }
        this.periodData.push({ 'label': period['records'][i]['表示名'].value, 'value': this.periodData.length, 'searchValue': period['records'][i]['期'].value })
      }

      setTimeout(() => {
        this.searchDataSetFlg = true
      }, 500)
      this.overlayShow = false
    },
    getSearchSelect (numList, dataList) {
      let res = []
      for (let i = 0; i < numList.length; i++) {
        res.push(dataList[numList[i]].searchValue)
      }
      return res
    },
    getSelectListDict (dataList) {
      let res = {}
      for (let i = 0; i < dataList.length; i++) {
        if (dataList[i] !== '') {
          res[dataList[i]] = dataList[i]
        }
      }
      return res
    },
    setUnits: async function () {
      if (this.searchDataSetFlg) {
        // 検索値初期化
        this.searchUnitName = []
      }

      // 選択肢絞込み
      let units = UnitListModel.getStore('units')
      this.unitData = []
      if (!units) {
        this.unitData.push({ 'label': '', 'value': '' })
        return
      }
      this.unitData.push({ 'label': this.selectAllText, 'value': 0, 'searchValue': '' })
      for (let i = 0; i < units['records'].length; i++) {
        let addflg = (this.searchAreaName.length === 0)
        // 権限上問題ないか確認
        if (this.setSelectItemsValidate(units['records'][i]['所属エリア'].value, units['records'][i]['ユニット名'].value)) {
          for (let j = 0; j < this.searchAreaName.length; j++) {
            if (this.areaData[this.searchAreaName[j]]) {
              // 現在の選択値が配列に存在しない場合は追加しない
              // 選択したエリアの対象か確認
              if (this.areaData[this.searchAreaName[j]]['label'] === units['records'][i]['所属エリア'].value || this.areaData[this.searchAreaName[j]]['label'] === this.selectAllText) {
                addflg = true
                break
              }
            }
          }
          if (addflg) {
            this.unitData.push({ 'label': units['records'][i]['ユニット名'].value, 'value': this.unitData.length, 'searchValue': units['records'][i]['ユニット名'].value })
          }
        }
      }
      // 空ならダミーデータを入れる
      if (this.unitData.length === 0) {
        this.unitData.push({ 'label': '', 'value': '', 'searchValue': '' })
      }
    },
    setFacilities: async function () {
      if (this.searchDataSetFlg) {
        // 検索値初期化
        this.searchFacilityCode = []
      }

      // 選択肢絞込み
      let facilities = FacilityListModel.getStore('facilities')
      this.facilityData = []
      if (!facilities) {
        this.facilityData.push({ 'label': '', 'value': '' })
        return
      }
      this.facilityData.push({ 'label': this.selectAllText, 'value': 0, 'searchValue': '' })
      for (let i = 0; i < facilities['records'].length; i++) {
        let areaflg = (this.searchAreaName.length === 0)
        // 権限上問題ないか確認
        if (this.setSelectItemsValidate(facilities['records'][i]['担当エリア'].value, facilities['records'][i]['担当ユニット'].value)) {
          for (let j = 0; j < this.searchAreaName.length; j++) {
            if (this.areaData[this.searchAreaName[j]]) {
              // 現在の選択値が配列に存在しない場合は追加しない
              // 選択したエリアの対象か確認
              if (this.areaData[this.searchAreaName[j]]['label'] === facilities['records'][i]['担当エリア'].value || this.areaData[this.searchAreaName[j]]['label'] === this.selectAllText) {
                areaflg = true
                break
              }
            }
          }
          let unitflg = (this.searchUnitName.length === 0)
          for (let j = 0; j < this.searchUnitName.length; j++) {
            if (this.unitData[this.searchUnitName[j]]) {
              // 現在の選択値が配列に存在しない場合は追加しない
              // 選択したユニットの対象か確認
              if (this.unitData[this.searchUnitName[j]]['label'] === facilities['records'][i]['担当ユニット'].value || this.unitData[this.searchUnitName[j]]['label'] === this.selectAllText) {
                unitflg = true
                break
              }
            }
          }
          if (areaflg && unitflg) {
            this.facilityData.push({ 'label': facilities['records'][i]['施設名'].value, 'value': this.facilityData.length, 'searchValue': facilities['records'][i]['施設コード'].value })
          }
        }
      }
      // 空ならダミーデータを入れる
      if (this.facilityData.length === 0) {
        this.facilityData.push({ 'label': '', 'value': '', 'searchValue': '', 'hideValue': '' })
      }
    },
    setVSelect (select, newData, oldData) {
      if (newData.length > 1 && this.searchDataSetFlg) {
        for (let j = 0; j < newData.length; j++) {
          if (newData[j] === 0) {
            if (select === 'searchAreaName') {
              if (oldData.length === 1 && oldData[0] === 0) {
                this.searchAreaName.splice(j, 1)
              } else {
                this.searchAreaName = [0]
              }
            } else if (select === 'searchUnitName') {
              if (oldData.length === 1 && oldData[0] === 0) {
                this.searchUnitName.splice(j, 1)
              } else {
                this.searchUnitName = [0]
              }
            } else if (select === 'searchFacilityCode') {
              if (oldData.length === 1 && oldData[0] === 0) {
                this.searchFacilityCode.splice(j, 1)
              } else {
                this.searchFacilityCode = [0]
              }
            } else if (select === 'searchPeriod') {
              if (oldData.length === 1 && oldData[0] === 0) {
                this.searchPeriod.splice(j, 1)
              } else {
                this.searchPeriod = [0]
              }
            }
            break
          }
        }
      }
    },
    tableNumberRegist: async function () {
      if (!this.isDecimal(this.tableNumber)) {
        this.$refs.commonModal.msgBoxOk('ゲストテーブル卓数には半角数字、または小数点第二位までの値を入力してください。')
        return false
      }
      this.overlayPlanListShow = true
      let params = {}
      params['tableNumber'] = this.tableNumber
      params['facilityCode'] = this.getSelectListDict(this.getSearchSelect(this.nowSearchFacilityCode, this.nowFacilityData))
      params['period'] = this.getSelectListDict(this.getSearchSelect(this.nowSearchPeriod, this.nowPeriodData))
      // 卓数更新処理
      await FocusTableNumberRegistModel.postApi(this.$bvModal, params, () => {
        this.overlayPlanListShow = false
      })
      // 再検索処理
      await this.searchFocusPlan(false, true)
      this.$refs.commonModal.msgBoxOk('ゲストテーブル卓数を更新いたしました。')
    }
  },
  computed: {
    getSearchAreaName () {
      return this.searchAreaName
    },
    getSearchUnitName () {
      return this.searchUnitName
    },
    getSearchFacilityCode () {
      return this.searchFacilityCode
    },
    getSearchPeriod () {
      return this.searchPeriod
    }
  },
  watch: {
    getSearchAreaName: function (newData, oldData) {
      this.setUnits()
      this.setFacilities()
      this.setVSelect('searchAreaName', newData, oldData)
    },
    getSearchUnitName: function (newData, oldData) {
      this.setFacilities()
      this.setVSelect('searchUnitName', newData, oldData)
    },
    getSearchFacilityCode: function (newData, oldData) {
      this.setVSelect('searchFacilityCode', newData, oldData)
    },
    getSearchPeriod: function (newData, oldData) {
      this.setVSelect('searchPeriod', newData, oldData)
    }
  },
  mounted: async function () {
    document.title = '棚割・注力設定'
    if (process.env.APP_ENV !== 'production') {
      document.title = '【テスト環境】棚割・注力設定'
    }
    await this.setApiData()
    if (this.userId) {
      // ソートを初期化
      await this.iniSortDirection()

      // 現在の仕様ではクッキーデータを使用しない
      // await this.setCookieData()
      // if (JSON.parse(localStorage.getItem('isOrderPageBack'))) {
      //  this.pageBackSetUp()
      // } else {
      this.clearConditions()
      // }

      // 選択肢の情報を取得
      await this.setSelectItems()
    }
  },
  created () {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>
<style>
.active-list {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
}
.list-type {
  padding: 0.5rem;
  color: #fefefe;
}
.list-type:hover {
  color: #fefefe;
  cursor: pointer;
}
.active-list:hover {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
  cursor: default;
  text-decoration: none;
}
.th-head {
  background-color: #cacfec !important;
  border: 1px solid #dee2e6 !important;
  color: #000000;
  font-weight: normal;
}

.th-cell {
  background-color: #FFFFFF !important;
  border: 1px solid #eefdff !important;
  color: #000000;
  font-weight: normal;
}

.white-line {
  background-color: #fff;
}
.white-line:hover {
  background-color: #d9efff !important;
}
.gray-line {
  background-color: #eefdff;
}
.gray-line:hover {
  background-color: #d9efff !important;
}
.tile-image-height {
  max-height: 140px;
  height: auto;
}

.star input[type='checkbox']{
  display: none;
}
.star label{
  color: #D2D2D2;
  font-size: 30px;
  cursor: pointer;
}
.star input[type='checkbox']:checked ~ label{
  color: #F8C601;
}
.no-pointer-events {
  Pointer-events: none;
}

.image-box {
  cursor: zoom-in !important;
  display: inline-block !important;
  padding: 0px !important;
  background-color: #FFF !important;
  border-color: #FFF !important;
}
.image-dialog {
  padding: 0;
  &::backdrop {
    cursor: zoom-out;
  }
  .contents img {
    vertical-align: top;
    height: 90vh;
    width: 70vw;
    object-fit: contain;
  }
}

.no-spin::-webkit-inner-spin-button,
.no-spin::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
    -moz-appearance:textfield !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/FocusSpecList.vue